<template>
    <select ref="select" class="admin-select" v-bind="$attrs" @change="handleChange">
        <slot>
            <option v-for="option in options" :key="String(option.value)" :value="option.value">
                {{ option.label }}
            </option>
        </slot>
    </select>
</template>

<script>
export default {
    name: "AdminSelect",
    inheritAttrs: false,
    props: {
        value: { default: undefined },
        options: { type: Array, default: () => [] },
    },
    watch: {
        value() {
            this.$nextTick(this.syncSelectedOption);
        },
        options() {
            this.$nextTick(this.syncSelectedOption);
        },
    },
    mounted() {
        this.syncSelectedOption();
    },
    updated() {
        this.syncSelectedOption();
    },
    methods: {
        optionValue(option) {
            return option && "_value" in option ? option._value : option.value;
        },
        valuesMatch(optionValue, value) {
            if (optionValue === value) return true;
            if (optionValue == null || value == null) return optionValue == null && value == null;
            return String(optionValue) === String(value);
        },
        syncSelectedOption() {
            if (this.value === undefined || !this.$refs.select) return;

            Array.from(this.$refs.select.options).forEach(option => {
                option.selected = this.valuesMatch(this.optionValue(option), this.value);
            });
        },
        handleChange(event) {
            const option = event.target.options[event.target.selectedIndex];
            this.$emit("input", this.optionValue(option));
            this.$emit("change", event);
        },
    },
};
</script>

<style scoped lang="scss">
.admin-select {
    width: 100%;
    min-height: 2.4rem;
    padding: 0.45rem 2.25rem 0.45rem 0.7rem;
    appearance: none;
    border: 1px solid #c8c8c8;
    border-radius: 4px;
    background-color: #fff;
    background-image:
        linear-gradient(45deg, transparent 50%, #666 50%),
        linear-gradient(135deg, #666 50%, transparent 50%);
    background-position:
        calc(100% - 0.9rem) calc(50% - 0.1rem),
        calc(100% - 0.6rem) calc(50% - 0.1rem);
    background-repeat: no-repeat;
    background-size: 0.3rem 0.3rem, 0.3rem 0.3rem;
    color: var(--color-mine-shaft);
    cursor: pointer;
    font-family: inherit;
    font-size: var(--font-size-sm);
    font-weight: var(--font-weight-semibold);
    line-height: 1.25;
    transition: border-color 0.15s ease, box-shadow 0.15s ease, background-color 0.15s ease;

    &:hover:not(:disabled) {
        border-color: #888;
        background-color: #fcfcfc;
    }

    &:focus {
        border-color: #555;
        outline: 0;
        box-shadow: 0 0 0 3px rgba(205, 27, 0, 0.12);
    }

    &:disabled {
        background-color: var(--color-gallery);
        color: var(--color-pip-gray);
        cursor: not-allowed;
        opacity: 0.7;
    }
}
</style>
